<template>



  <v-container
    fluid
    grid-list-xl
  >
    <v-row>
      <v-col>
      <v-btn color="primary" to="/projectCreate"
             v-if="userHasAuthority('MANAGE_PROJECTS')">
        {{$t("projects.list.create")}}
      </v-btn>
      </v-col>
    </v-row>


    <v-row>
      <v-col cols="10">
        <v-switch
          v-model="includeInactive"
          :label="$t('projects.list.includeInactive')"
        ></v-switch>
        <v-text-field
          :label="$t('global.search')"
          single-line
          hide-details
          v-model="search"
        ></v-text-field>

        <material-card
          :title="$t('projects.list.title')"
        >

          <v-data-table
            :headers="headers"
            :items="projects"
            :search="search"

            @click:row="showProject"
            hide-default-footer
            :items-per-page=1000
          >


          </v-data-table>
        </material-card>
      </v-col>


    </v-row>
  </v-container>
</template>

<script>
    import api from '../components/backend/backend-api'

    export default {
        data: function () {
            return {
                search: '',
                headers: [
                    {
                        sortable: true,
                        text: this.$i18n.t("project.name"),
                        value: 'name'
                    },
                    {
                        sortable: true,
                        text: this.$i18n.t("project.projectNumber"),
                        value: 'projectNumber'
                    },
                    {
                        sortable: true,
                        text: this.$i18n.t("project.projectType"),
                        value: 'projectType'
                    },
                  {
                    sortable: true,
                    text: this.$i18n.t("project.department"),
                    value: 'department'
                  },
                    {
                        sortable: true,
                        text: this.$i18n.t("project.lastEdited"),
                        value: 'lastEditedDate'
                    }
                ],
                projects: [],
                includeInactive:false
            }
        },
        methods: {
            showProject (rowdata) {
                this.$router.push({ path: '/projectShow/' + rowdata.id })
            },
            getProjects () {
              api.getProjects(this.includeInactive).then(response => {


                this.projects = response.map(function (ele) {
                  return {
                    'id': ele.id,
                    'name': ele.name,
                    'projectNumber': ele.projectNumber,
                    "projectType": ele.projectType.name,
                    "department": ele.department.name,
                    "lastEditedDate": ele.lastEditedDate

                  }
                })


                })
                .catch(error => {
                  this.$store.commit('setErrorMsg', error)
                  console.log(error)
                  //    this.errors.push(error)
                })
            }
        },
        watch: {
            currentUser: function () {
                this.getProjects();
            },
            includeInactive: function() {
                this.getProjects();
            }
        },
        mounted() {
            if (this.currentUser!='')
              this.getProjects();
              //this.$ga.set("dimension1", this.$store.state.curCustomer)
        },
    }
</script>
